var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loyalty-dropdown-analytics',{attrs:{"title":_vm.$t('breadcrumb.loyalty')}}),(_vm.fechaHasta && _vm.appProgram)?_c('analytics'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }